export default "__VITE_ASSET__Bmzk8t0u__"